/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ServicedeskKnowledgeHubCategoryType from '@jira/spa-apps__servicedesk-knowledge-hub-category/src/index.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyServicedeskKnowledgeHubCategory: LazyComponent<() => React.JSX.Element> =
	lazyForPaint<typeof ServicedeskKnowledgeHubCategoryType>(() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-servicedesk-knowledge-hub-category", jiraSpaEntry: "async-servicedesk-knowledge-hub-category" */ '@jira/spa-apps__servicedesk-knowledge-hub-category/src/index.tsx'
			),
		),
	);

const AsyncServicedeskKnowledgeHubCategory = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskKnowledgeHubCategory}
		pageId="spa-apps/servicedesk/knowledge-hub/category"
		shouldShowSpinner
	/>
);

export default AsyncServicedeskKnowledgeHubCategory;
